import {clientsClaim as workbox_core_clientsClaim} from '/home/nicorivas/onstageobra-react-js/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/nicorivas/onstageobra-react-js/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {registerRoute as workbox_routing_registerRoute} from '/home/nicorivas/onstageobra-react-js/node_modules/workbox-routing/registerRoute.mjs';
import {NavigationRoute as workbox_routing_NavigationRoute} from '/home/nicorivas/onstageobra-react-js/node_modules/workbox-routing/NavigationRoute.mjs';
import {createHandlerBoundToURL as workbox_precaching_createHandlerBoundToURL} from '/home/nicorivas/onstageobra-react-js/node_modules/workbox-precaching/createHandlerBoundToURL.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/static/react/../../templates/others/react_app.html",
    "revision": "5765c0a130c7098e022220ddb4333880"
  },
  {
    "url": "/static/react/0e4a9948afcacf7435b4.ttf",
    "revision": null
  },
  {
    "url": "/static/react/429ce8eb3893b90c8e68.svg",
    "revision": null
  },
  {
    "url": "/static/react/501cc2a4d91e2780fe9a.ttf",
    "revision": null
  },
  {
    "url": "/static/react/6b2979ab7d329c25f846.svg",
    "revision": null
  },
  {
    "url": "/static/react/7352b5bd224a9694d1e5.svg",
    "revision": null
  },
  {
    "url": "/static/react/9a15ba69dd742feb4db2.svg",
    "revision": null
  },
  {
    "url": "/static/react/b81ec229a514a92f06c4.ttf",
    "revision": null
  },
  {
    "url": "/static/react/bd686bfc3f191cdf30e7.svg",
    "revision": null
  },
  {
    "url": "/static/react/be327e723414763bf934.ttf",
    "revision": null
  },
  {
    "url": "/static/react/css/996.effd4b38.css",
    "revision": null
  },
  {
    "url": "/static/react/css/main.595cb5e0.css",
    "revision": null
  },
  {
    "url": "/static/react/js/996.b612b5af.js.LICENSE.txt",
    "revision": "6b644d5e7afba7ee96d86942abda1689"
  },
  {
    "url": "/static/react/js/main.be6f022a.js",
    "revision": null
  },
  {
    "url": "/static/react/js/runtime-main.361d0b56.js",
    "revision": null
  },
  {
    "url": "/static/react/media/AKZC3Y+AA==.d54734eb.bin",
    "revision": "4dc329771da4d53d46586ddfd0590cfc"
  },
  {
    "url": "/static/react/media/Rubik-Bold.d6173c48.ttf",
    "revision": "9a6fb6f5cd3aa4ab1adaaab1f693f266"
  },
  {
    "url": "/static/react/media/Rubik-Light.8e4b0184.ttf",
    "revision": "7a06846baf7fd2cfb18c7ab4d663c8ca"
  },
  {
    "url": "/static/react/media/Rubik-Medium.4ddab52b.ttf",
    "revision": "c87313aa86b7caa31a9a0accaa584970"
  },
  {
    "url": "/static/react/media/Rubik-Regular.37a4d906.ttf",
    "revision": "b3d0902b533ff4c4f1698a2f96ddabab"
  },
  {
    "url": "/static/react/media/bnBl1mLvAAAAAElFTkSuQmCC.7cbb4f41.bin",
    "revision": "6e5abcb734b5786a16f046ae45a1111c"
  },
  {
    "url": "/static/react/media/javascript,__webpack_public_path__ = __webpack_base_uri__ = htmlWebpackPluginPublicPath;.1feff74f.bin",
    "revision": "aed5664e42105e46cf2a61b59786988d"
  },
  {
    "url": "/static/react/media/logo.942a36d5.png",
    "revision": "385410c2d2cdf01ae06e6af138c47186"
  },
  {
    "url": "/static/react/media/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAABlBMVEUAAAAAAAClZ7nPAAAAAXRSTlMAQObYZgAAABZJREFUeAFjIAUwUshlpJDLSIhLGAAACQ4AFk79JaMAAAAASUVORK5CYII=.8994dc0f.bin",
    "revision": "324e39c6cd09fce713323f25cedce495"
  },
  {
    "url": "/static/react/media/svg%3E.19f72bca.bin",
    "revision": "0787022d97a718c0a165bab85731911c"
  },
  {
    "url": "/static/react/media/svg%3E.1a833728.bin",
    "revision": "e55c4d6fd5354ef8a26dd94400b762d9"
  },
  {
    "url": "/static/react/media/svg%3E.20a7e999.bin",
    "revision": "1545468abc31a6957a0db6c0c6dc8f13"
  },
  {
    "url": "/static/react/media/svg%3E.2e52ef86.bin",
    "revision": "664982677ff1f3b068ae17ceb763b238"
  },
  {
    "url": "/static/react/media/svg%3E.400a94a7.bin",
    "revision": "ab31ed0b0d0b23306dcef041bbe7995a"
  },
  {
    "url": "/static/react/media/svg%3E.40a9c4c3.bin",
    "revision": "ee3cf9bb1703d4bddb4b12b8b27a435e"
  },
  {
    "url": "/static/react/media/svg%3E.430b5662.bin",
    "revision": "abc1f4f2dd84e9882e96b8e90a900b77"
  },
  {
    "url": "/static/react/media/svg%3E.4390e95b.bin",
    "revision": "c72abc4a3d06f2d734b3eedcb9070099"
  },
  {
    "url": "/static/react/media/svg%3E.59e827f7.bin",
    "revision": "ff75d9a617b4e4f69f8698bb7f5fe272"
  },
  {
    "url": "/static/react/media/svg%3E.5ab108c2.bin",
    "revision": "cf93c4dc2adad7048be63cc21d636304"
  },
  {
    "url": "/static/react/media/svg%3E.6385ec04.bin",
    "revision": "ca78bf1ff2283e6024c807638d5ff209"
  },
  {
    "url": "/static/react/media/svg%3E.646683be.bin",
    "revision": "4ca888bf9df60ab6e4ab4f68c23a605d"
  },
  {
    "url": "/static/react/media/svg%3E.78b8e669.bin",
    "revision": "9967ac13e2e54fe67a711354582225c7"
  },
  {
    "url": "/static/react/media/svg%3E.8373f613.bin",
    "revision": "64f55b9d0eb531fe1ca7c8f21827249b"
  },
  {
    "url": "/static/react/media/svg%3E.87ac6231.bin",
    "revision": "7a12870b999c513380eef949b89d8388"
  },
  {
    "url": "/static/react/media/svg%3E.8c60ea7b.bin",
    "revision": "0a0bee1b6278945fe06cdf5ed33bcc9f"
  },
  {
    "url": "/static/react/media/svg%3E.938979c7.bin",
    "revision": "b7ad6862a4bce98633492359cd111dd5"
  },
  {
    "url": "/static/react/media/svg%3E.9428f822.bin",
    "revision": "df02994f6bb8281a8b1b39e4aa58e833"
  },
  {
    "url": "/static/react/media/svg%3E.9f1ee3c6.bin",
    "revision": "b478cb909412fdad34d999d3d9da02f0"
  },
  {
    "url": "/static/react/media/svg%3E.a2042250.bin",
    "revision": "e8682a30dd78e2a4aff2d106a35dcb2d"
  },
  {
    "url": "/static/react/media/svg%3E.a597785c.bin",
    "revision": "8fbea184543f9458dc6ab5c56ac46230"
  },
  {
    "url": "/static/react/media/svg%3E.a98eb95d.bin",
    "revision": "328ed7cfaf16d2769a419a4245b1f2d5"
  },
  {
    "url": "/static/react/media/svg%3E.adfbec3e.bin",
    "revision": "a50bc93e949deb8949af2e0ae5080b56"
  },
  {
    "url": "/static/react/media/svg%3E.ae251871.bin",
    "revision": "abed9d176f887dc9334506a02f9dc420"
  },
  {
    "url": "/static/react/media/svg%3E.ae6f1778.bin",
    "revision": "3b879792786c43bab7f4011e20612ab0"
  },
  {
    "url": "/static/react/media/svg%3E.b9d91f16.bin",
    "revision": "89d69c2306d9066a0348ce64c872ff80"
  },
  {
    "url": "/static/react/media/svg%3E.cbb67e0d.bin",
    "revision": "d411ec43ac46ccb89248dcea722b2c4f"
  },
  {
    "url": "/static/react/media/svg%3E.d3099a56.bin",
    "revision": "be74f71961f57bede0d622c676cd0ec4"
  },
  {
    "url": "/static/react/media/svg%3E.f5194ade.bin",
    "revision": "678c2fb3f75e5bbd6b8634d023865f9e"
  },
  {
    "url": "/static/react/media/svg%3E.f7f91ebe.bin",
    "revision": "5c3198b9af0bff606aa689a74ca187df"
  },
  {
    "url": "/static/react/media/svg%3e.05a01895.bin",
    "revision": "0503cb037d82721e4d8f8134ce9991dc"
  },
  {
    "url": "/static/react/media/svg%3e.0ddc91a1.bin",
    "revision": "79f24a90d0cb1e0fa263894eccebf340"
  },
  {
    "url": "/static/react/media/svg%3e.297d72b7.bin",
    "revision": "0ee7d423abbf193b3df336fbc4df30a1"
  },
  {
    "url": "/static/react/media/svg%3e.733dd34c.bin",
    "revision": "1355935497ff36bfb32af51f4195ffe5"
  },
  {
    "url": "/static/react/media/svg%3e.8a367b91.bin",
    "revision": "1931458161c2845957bb0924e26998de"
  },
  {
    "url": "/static/react/media/svg%3e.8b90ed59.bin",
    "revision": "37f00f6364a8fb5a0696282572b6aa7c"
  },
  {
    "url": "/static/react/media/svg%3e.abdd189f.bin",
    "revision": "4adba009d97ef317981523a070cdd8cb"
  },
  {
    "url": "/static/react/media/svg%3e.ba125c4a.bin",
    "revision": "ee89749e559befc1cc23f0c8c907fbe9"
  },
  {
    "url": "/static/react/media/svg%3e.c7db43d0.bin",
    "revision": "6ba3a071885b35b290347243d06c9623"
  },
  {
    "url": "/static/react/media/svg%3e.e39e1b36.bin",
    "revision": "fc539485f8a278f2f241bd5bc9fc24a0"
  },
  {
    "url": "/static/react/media/svg>.15e707d4.bin",
    "revision": "13533ec4803541d33eda1eb5979178e2"
  },
  {
    "url": "/static/react/media/svg>.42a9fd25.bin",
    "revision": "102239006bf2d2a186fb6dfa0005f907"
  },
  {
    "url": "/static/react/media/svg>.7cd62d4d.bin",
    "revision": "f3e13cb62e174a563b057974823c1cc2"
  },
  {
    "url": "/static/react/media/svg>.8690aa48.bin",
    "revision": "9bcd7b7517f9d44b7b0ba4dbe528c122"
  },
  {
    "url": "/static/react/media/svg>.99b06972.bin",
    "revision": "dc07346815b77495fc3b733929dc752a"
  },
  {
    "url": "/static/react/media/svg>.afd0089d.bin",
    "revision": "fb3852554b9c753383b03ac644b44a01"
  },
  {
    "url": "/static/react/media/svg>.e8692eaf.bin",
    "revision": "f15a1ade80260c20c21e20724eec790b"
  }
], {});

workbox_routing_registerRoute(new workbox_routing_NavigationRoute(workbox_precaching_createHandlerBoundToURL("/static/react/index.html"), {
  
  denylist: [/^\/_/,/\/[^/?]+\.[^/]+$/],
}));






